export const TYPES = {
  SET_DRAFT_DIALOG_ALL: "draft_dialog/SET_DRAFT_DIALOG_ALL",
  SET_DRAFT_DIALOG_OPEN_ADD: "draft_dialog/SET_DRAFT_DIALOG_OPEN_ADD",
  SET_DRAFT_DIALOG_OPEN_EDIT: "draft_dialog/SET_DRAFT_DIALOG_OPEN_EDIT",
  SET_DRAFT_DIALOG_SELECTED: "draft_dialog/SET_DRAFT_DIALOG_SELECTED",
  SET_DRAFT_DIALOG_SEARCH: "draft_dialog/SET_DRAFT_DIALOG_SEARCH",
  //
  SET_DRAFT_DIALOG_DETAIL: "draft_dialog/SET_DRAFT_DIALOG_DETAIL",
  SET_DRAFT_DIALOG_OPEN_DENY: "draft_dialog/SET_DRAFT_DIALOG_OPEN_DENY",
  SET_DRAFT_DIALOG_OPEN_WARN: "draft_dialog/SET_DRAFT_DIALOG_OPEN_WARN",
  SET_DRAFT_DIALOG_OPEN_FORWARD: "draft_dialog/SET_DRAFT_DIALOG_OPEN_FORWARD",
  //
  SET_DRAFT_DIALOG_AUDIO_URL: "draft_dialog/SET_DRAFT_DIALOG_AUDIO_URL",
  SET_DRAFT_DIALOG_PLAY: "draft_dialog/SET_DRAFT_DIALOG_PLAY",
  SET_DRAFT_DIALOG_SECOND: "draft_dialog/SET_DRAFT_DIALOG_SECOND",
  SET_DRAFT_DIALOG_KICK: "draft_dialog/SET_DRAFT_DIALOG_KICK",
};
